import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import ChatManagerInstance from "./ChatManager";
import axios from "axios";

var BroadcastThreadManager = /*#__PURE__*/function () {
  function BroadcastThreadManager() {
    _classCallCheck(this, BroadcastThreadManager);

    this.accessToken = null;
    this.threadName = null;
  }

  _createClass(BroadcastThreadManager, [{
    key: "buildHeaders",
    value: function buildHeaders() {
      return {
        "Authorization": "Bearer " + this.accessToken,
        "Content-Type": "application/json"
      };
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(url, method, dataBody, abortSignal) {
      return axios({
        method: method,
        url: url,
        data: dataBody,
        headers: this.buildHeaders(),
        signal: abortSignal
      });
    }
  }, {
    key: "init",
    value: function init(accessToken, threadName) {
      this.accessToken = accessToken;
      this.threadName = threadName;
    }
  }, {
    key: "getAPIUserDetailsURL",
    value: function getAPIUserDetailsURL() {
      return ChatManagerInstance.restApiURL + "/broadcastThreads/" + this.threadName + "/userDetails";
    }
  }, {
    key: "getUserDetails",
    value: function getUserDetails(abortSignal) {
      return this.sendRequest(this.getAPIUserDetailsURL(), "GET", void 0, abortSignal);
    }
  }, {
    key: "getAPIAroundMessagesURL",
    value: function getAPIAroundMessagesURL(timestamp, beforeSize, afterSize) {
      var url = ChatManagerInstance.restApiURL + "/broadcastThreads/" + this.threadName;
      url += "/aroundMessages?beforeSize=" + beforeSize + "&afterSize=" + afterSize + "&timestamp=" + timestamp;
      return url;
    }
  }, {
    key: "loadAroundMessages",
    value: function loadAroundMessages(timestamp, beforeSize, afterSize, abortSignal) {
      return this.sendRequest(this.getAPIAroundMessagesURL(timestamp, beforeSize, afterSize), "GET", void 0, abortSignal);
    }
  }, {
    key: "updateLastReadTimestamp",
    value: function updateLastReadTimestamp(lastReadTimestamp, abortSignal) {
      return this.sendRequest(this.getAPIUserDetailsURL(), "PATCH", {
        lastReadTimestamp: lastReadTimestamp
      }, abortSignal);
    }
  }, {
    key: "toggleDisabledThread",
    value: function toggleDisabledThread(disabled, abortSignal) {
      return this.sendRequest(this.getAPIUserDetailsURL(), "PATCH", {
        disabled: disabled
      }, abortSignal);
    }
  }]);

  return BroadcastThreadManager;
}();

var BroadcastThreadManager_default = new BroadcastThreadManager();
export { BroadcastThreadManager_default as default };